import React, { Component } from 'react';
import _ from 'lodash';

import ReactDOM from 'react-dom';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import utils from 'Utils/index.js';

import style from './style.scss';

import DeliveriesListItemContainer from '../DeliveriesListItem/DeliveriesListItemContainer';

const MAX_OPENED_COUNT = 3;

export default class DeliveriesList extends Component{

  constructor(props) {
    super(props);

    this.state = {
    };


  }


  componentWillReceiveProps(){

  }

  render() {

    const {deliveries: deliveries_raw, app_data, refetch, date_moment} = this.props;
    const role = app_data.roles[app_data.user.role_id];

    const {
      INITIALIZED,
      COMPLETED,
      IN_PROGRESS,
      CANCELED
    } = app_data.constants.delivery;

    const sort_weights = {
      [INITIALIZED]: 2,
      [COMPLETED]: 3,
      [IN_PROGRESS]: 1,
      [CANCELED]: 4
    };

    const deliveries = deliveries_raw.filter(delivery => {
      if(app_data.user.access.delivery.all) {
        return true;
      }

      if(delivery.user_id !== null && delivery.user_id !== app_data.user.id) {
        return false;
      }
      return true;
    });

    const sorted_deliveries = [...deliveries].sort((a, b) => {

      a = {...a};
      b = {...b};

      a.status_id = a.status_id || INITIALIZED;
      b.status_id = b.status_id || INITIALIZED;


      return sort_weights[a.status_id] < sort_weights[b.status_id] ? -1 : 1;
    });

    const openedCount = deliveries.reduce((acc, delivery) => {
      const isDeliveryOpened = ![COMPLETED, CANCELED, INITIALIZED, null].includes(delivery.status_id);
      if(isDeliveryOpened) {
        acc++;
      }
      return acc;
    }, 0);

    const canOpen = openedCount < MAX_OPENED_COUNT;

    // console.log(sorted_deliveries);
    //
    // sorted_deliveries.forEach(a => {
    //   console.log(a);
    //   console.log(sort_weights[a.status_id]);
    // });

    const drivers_hash = _.keyBy(app_data.drivers, 'id');

    const cost_by_driver = _.reduce(deliveries, (obj, delivery) => {

      if(delivery.user_id && delivery.status_id === COMPLETED) {
        !obj[delivery.user_id] && (obj[delivery.user_id] = {
          cost:0,
          title: drivers_hash[delivery.user_id].name,
          id: delivery.user_id
        });

        let cost = 12;

        if(delivery.contractor_id && app_data.contractors[delivery.contractor_id].cost) {
          cost = app_data.contractors[delivery.contractor_id].cost;
        }

        if(delivery.type_id === 7) {
          cost = 5;
        }

        obj[delivery.user_id].cost += cost;

      }
      return obj;
    }, {});

    const cost_by_driver_list = _.reduce(cost_by_driver, (arr, obj, id) => {

      arr.push(obj);

      return arr;
    }, []);


    const deliveries_by_time = _.reduce(deliveries, (obj, delivery) => {

      const end_moment = moment(delivery.time.split('-')[1], utils.TIME_FORMAT);

      if(moment('13:00', utils.TIME_FORMAT).add(1, 'minute').isAfter(end_moment)){

        obj['9-13'].count++;

      } else if(moment('18:00', utils.TIME_FORMAT).add(1, 'minute').isAfter(end_moment)) {

        obj['13-18'].count++;

      } else {

        obj['18-22'].count++;

      }

      return obj;

    }, {
      '9-13': {
        title: '9:00 - 13:00',
        max_count: 4,
        count: 0,
      },
      '13-18': {
        title: '13:00 - 18:00',
        max_count: 8,
        count: 0,
      },
      '18-22': {
        title: '18:00 - 22:00',
        max_count: 6,
        count: 0,
      }
    });

    const deliveries_by_time_list = _.reduce(deliveries_by_time, (list, data, id) => {

      list.push({
        ...data,
        id
      });

      return list;
    }, [])



    // выбранный винтерфейсе день - это следующий день
    const next_day_and_selected_day_same = date_moment.isAfter(moment().endOf('day'));

    // 8 часов вечера текущего дня
    const show_moment = moment().endOf('day').subtract(5, 'hours');

    // больше 8 часов текущего дня
    const is_show_moment_now = moment().isAfter(show_moment);

    // есть запрет просмотра следующего дня и не наступил момент открытия списка
    if(!app_data.user.access.deliveries.show_next_day && next_day_and_selected_day_same && !is_show_moment_now) {
      return <div> </div>;
    }


    return (
      <div >


        <div className="deliveries_list__grid">

          <div>
            {cost_by_driver_list.map(cost => {
              return <div key={cost.id}>
                <b>{cost.title}</b>: {cost.cost} руб.<br/>

              </div>
            })}
          </div>

          <div>
            {role.name !== 'driver' && (
              <>
                <b>Порядок записи:</b> 
                <br/>по-умолчанию с 13:00-21:00(если весь день дома), 
                <br/>если клиенту не подходит - выбираем удобный для клиента промежуток <br/>
              </>
            )}
            {deliveries_by_time_list.map((data, id) => {
              return <div key={id}>
                <b>{data.title}</b>: {data.count} из {data.max_count}<br/>

              </div>
            })}
          </div>

          <div>
            <b>Доставок всего</b>: {deliveries.length}<br/>
          </div>

          {sorted_deliveries.map((delivery) => {
            return (
              <DeliveriesListItemContainer
                key={delivery.id}
                delivery={delivery}
                app_data={app_data}
                refetchDeliveries={refetch}
                date_moment={date_moment}
                canOpen={canOpen}
              />
            )
          })}
        </div>
      </div>
    );
  }
}

